import { Routes, Route, Navigate } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { FeesPage } from "./pages/FeesPage";
import { CashierPage } from "./pages/CashierPage";
import { UsersPage } from "./pages/UsersPage";
import { StudentsPage } from "./pages/StudentsPage";
import { MasterDataPage } from "./pages/MasterDataPage";
import { StaffPage } from "./pages/StaffPage";
import { ExamsPage } from "./pages/ExamsPage";
import { NotificationsPage } from "./pages/NotificationsPage";
import { AttendancePage } from "./pages/AttendancePage";
import { TimetablePage } from "./pages/TimetablePage";
import { AcademicsPage } from "./pages/AcademicsPage";
import { ClassTestsPage } from "./pages/ClassTestsPage";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AppLayout } from "./components/AppLayout";
import { useAuth } from "./lib/auth";
import { canAccess } from "./lib/rbac";

// Role guard: renders children only if the user's role may access `path`,
// otherwise redirects to the dashboard.
function RoleRoute({ path, children }: { path: string; children: JSX.Element }) {
  const { user } = useAuth();
  return canAccess(user, path) ? children : <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/students" element={<RoleRoute path="/students"><StudentsPage /></RoleRoute>} />
        <Route path="/master-data" element={<RoleRoute path="/master-data"><MasterDataPage /></RoleRoute>} />
        <Route path="/staff" element={<RoleRoute path="/staff"><StaffPage /></RoleRoute>} />
        <Route path="/attendance" element={<RoleRoute path="/attendance"><AttendancePage /></RoleRoute>} />
        <Route path="/cashier" element={<RoleRoute path="/cashier"><CashierPage /></RoleRoute>} />
        <Route path="/users" element={<RoleRoute path="/users"><UsersPage /></RoleRoute>} />
        <Route path="/fees" element={<RoleRoute path="/fees"><FeesPage /></RoleRoute>} />
        <Route path="/exams" element={<RoleRoute path="/exams"><ExamsPage /></RoleRoute>} />
        <Route path="/class-tests" element={<RoleRoute path="/class-tests"><ClassTestsPage /></RoleRoute>} />
        <Route path="/academics" element={<RoleRoute path="/academics"><AcademicsPage /></RoleRoute>} />
        <Route path="/notifications" element={<RoleRoute path="/notifications"><NotificationsPage /></RoleRoute>} />
        <Route path="/timetable" element={<RoleRoute path="/timetable"><TimetablePage /></RoleRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
